import React, { useEffect, useRef, useState } from "react";
import "./Dialer.scss";
import CsvUploader from "./CsvUploader";
import LoaderScreen from "./LoaderScreen";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import personCalling from "../../../assets/images/solar_phone-linear.png";
import { formatSecondsToTime } from "../../../helper";
import { isValidPhoneNumber } from "react-phone-number-input";
import { flask_url, node_url } from "../../../Socket";
import axios from "axios";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { TableCSV, columnsCsv, columnsHubspot } from "../Table/Table";
import { TableHubspot } from "../Table/Table";
import { agentName } from "../Agents/scratchScript";
import { message } from "antd";
import { Navigate } from "react-router-dom";

const NewDialer = () => {
  const [loading, setLoading] = useState(false);
  var stuff = localStorage.getItem("name");
  const [selectedValue, setSelectedValue] = useState("All");
  const [selectedLead_status, setSelectedLead_status] = useState("All");
  const [selectedLead_Stage, setSelectedLead_Stage] = useState("All");
  const [selectedpropertytype, setSelectedpropertytype] = useState("All");
  const [uniqueCities, setUniqueCities] = useState([]);
  const [Lead_status, setLead_status] = useState();
  const [Lead_Stage, setLead_Stage] = useState();
  const [propertytype, setpropertytype] = useState();
  const [Subject, setSubject] = useState();
  const [Message, setMessage] = useState();
  const [SMS, setSMS] = useState();
  const [find, setFind] =useState(false)

  const [userUri, setUserUri] = useState(null);
  const [eventTypes, setEventTypes] = useState([]);
  const [tokenID, setToken] = useState([]);

  const API_TOKEN = "eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiUEFUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNzI3NzYyNzk3LCJqdGkiOiJiMDZkNzlhOS1iMjljLTQxNTUtOGY4YS1iOGIyMzcyM2QyZjAiLCJ1c2VyX3V1aWQiOiJkMjUzN2QyNi05MzUxLTRjNTYtOTkyNy1hYzEzMmE2NTZiM2YifQ.M6k4hTjNyQW38iKyW15o9Y1NtHdj7bJzRkN0j_mKo_QtiTmeyRoqh2Mg8BCZGJzLhW_ZG32M6eMGKo1yq1wtfg"; // Replace with your actual auth token
  const BASE_URL = "https://api.calendly.com";
  const headers = {
    Authorization: `Bearer ${API_TOKEN}`,
    "Content-Type": "application/json",
  };


  const getUserUri = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/users/me`, { headers });
      if (response.status === 200) {
        const userUri = response.data.resource.uri;
        console.log("userUri"+userUri);
        setUserUri(userUri);
      } else {
        console.error("Error fetching user URI:", response.data);
      }
    } catch (error) {
      console.error("Error fetching user URI:", error);
    }
  };

  // Function to get event types based on user URI
  const getEventTypes = async (userUri) => {
    try {
      const url = `${BASE_URL}/event_types`;
      const params = { user: userUri };
      const response = await axios.get(url, { headers, params });

      if (response.status === 200) {
        const data = response.data.collection;
        console.log("collection" , data);
        setEventTypes(data);
      } else {
        console.error(`Error fetching event types: ${response.status}`);
      }
    } catch (error) {
      console.error("Error fetching event types:", error);
    }
  };

  // useEffect(() => {
  //   // Fetch user URI when component mounts
  //   getUserUri();
  // }, []);

  useEffect(() => {
    // Fetch event types when the userUri is available
    if (userUri) {
      getEventTypes(userUri);
    }
  }, [userUri]);



  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleChangeLead_status = (event) => {
    setSelectedLead_status(event.target.value);
  };

  const handleChangeLeadStage = (event) => {
    setSelectedLead_Stage(event.target.value);
  };

  const handleChangeproperty = (event) => {
    setSelectedpropertytype(event.target.value);
  };

  if (stuff && stuff != "undefined") {
    var name = JSON.parse(localStorage.getItem("name"));
  }

  const [selectedAgents, setSelectedAgents] = useState({});

  useEffect(() => {
    fechAgents();
  }, []);

  const [customerData, setCustomerData] = useState(null);
  const [checkNumber, setCheckNumber] = useState(false);
  const [showMannudalDialer, setShowMannudalDialer] = useState("aidilaer");

  const [agentData, setAgentData] = useState([
    {
      number: "",
      name: "",
    },
    {
      number: "",
      name: "",
    },
    {
      number: "",
      name: "",
    },
    {
      number: "",
      name: "",
    },
    {
      number: "",
      name: "",
    },
  ]);

  const handleInputChange = (value, index, field) => {
    const updatedAgentData = [...agentData];
    updatedAgentData[index][field] = value;

    setAgentData(updatedAgentData);

    if (
      agentData.some(
        (value) =>
          value.name !== "" &&
          value.number !== undefined &&
          value.number > 3 &&
          isValidPhoneNumber(value.number.toString()) != false
      )
    ) {
      setCheckNumber(true);
    } else {
      setCheckNumber(false);
    }
  };

  const handleShowMannudalDialer = (tab) => {
    setShowMannudalDialer(tab);
  };

  const [userLogs, setUserLogs] = useState([]);

  // useEffect(() => {
  //   var id = JSON.parse(localStorage.getItem("userId"));
  //   getLogs(id);
  //   // getDialerStatus();
  // }, []);

  // const getLogs = async (id) => {
  //   try {
  //     const url = `https://gpd-production.onrender.com/get_data/${id}`;

  //     fetch(url)
  //       .then((response) => {
  //         if (!response.ok) {
  //           throw new Error(`HTTP error! Status: ${response.status}`);
  //         }
  //         return response.json();
  //       })
  //       .then((data) => {
  //         setUserLogs(data?.data);
  //         console.log(data?.data);
  //       })
  //       .catch((error) => {
  //         console.error("Error:", error);
  //       });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "Are you sure you want to leave this page?";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  let DailingHubspot = "";
  DailingHubspot = localStorage.getItem("DAILINGHUBSPOT") || false;
  console.log("DailingHubspot", DailingHubspot);

  const [showDialer, setshowDialer] = useState(DailingHubspot);
  const [dataFromChild, setDataFromChild] = useState(false);

  const getLoader = (loader) => {
    setDataFromChild(loader);
  };

  const [numberInput, setNumberInput] = useState(false);
  const getNumberInput = (number) => {
    setNumberInput(number);
  };

  // ------------------------------------------------------------------------

  const [selectedOption, setSelectedOption] = useState(null);

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const [value, setValue] = useState();

  const [csvData, setCsvData] = useState(null);
  const [hubspotDat, setHubSpotData] = useState([]);
  const [HubspotAgent, setHubspotAgent] = useState([]);

  useEffect(() => {
    getHubspotContacts();
  }, []);

  const getHubspotContacts = async () => {
    try {
      axios
        .get(`${node_url}/customer/hubspot-contacts`)
        .then((response) => {
          const data = response?.data?.results;
          setHubSpotData(response?.data?.results);
          setShowDailingStartBTN(true);
          const newStuff = data.map((item) => {
            return {
              ...item,
              agentId: "661fb4996c5d8aeca71a2f21",
            };
          });
          setLoading(false);
          setHubspotAgent(newStuff);
          setFind(true)
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const [chooseAgent, setChooseAgents] = useState([]);

  const fechAgents = async () => {
    try {
      setLoading(true)
      const token = JSON.parse(localStorage.getItem("bearerToken"));
      if (!token) return;
      await axios
        .get(`${process.env.REACT_APP_API_URL}/customer/agents`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setLoading(false)
          setChooseAgents(response.data);
          Navigate("/");
        })
        .catch((error) => {
          console.log(error.message);
        });
    } catch (error) {
      console.error("Error fetching agents:", error);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Calculate the index range for the current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Get the current page data
  // let currentData = HubspotAgent.slice(startIndex, endIndex);
  // let currentData =""
  const [currentData, setCurrentData] = useState();

  useEffect(() => {
    if (HubspotAgent.length === 0) return;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setCurrentData(HubspotAgent.slice(startIndex, endIndex));
  }, [HubspotAgent, currentPage]);

  const StartMaunualHubSpotDialer = async (data) => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      fetch(`${flask_url}/start-dialing_Hubspot`, requestOptions)
        .then((response) => response.json())
        .catch((error) => {
          console.error("Error during POST request:", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const [updatehubsotArray, setupdatehubsotArray] = useState(HubspotAgent);
  const [SelectedValueEmail, setSelectedValueEmail] = useState("");
  const [SelectedValueEvents, setSelectedValueEvents] = useState(HubspotAgent);
  // Function to handle select change

  const handleSelectChangeEmail = (event, id, index) => {
    const { value } = event.target;
    setSelectedValueEmail(value);
  };
  const handleSelectChangeEvents = (event, id, index) => {
    const { value } = event.target;
    setSelectedValueEvents(value);
  };

  const handleSelectChange = (event, id, index) => {
    const { value } = event.target;
    const selectedIndex = event.target.selectedIndex;
    const selectedElement = event.target.childNodes[selectedIndex];
    // setSelectedValueai(selectedElement)

    setfilteredData((prev) => {
      const updatedArray = [...prev];

      const updatedObject = {
        ...updatedArray[index],
        agentId: value,
        agentName: selectedElement.textContent,
      };

      updatedArray[index] = updatedObject;
      return updatedArray;
    });
  };

  const [currentPageOldLogs, setCurrentPageOldLogs] = useState(1);
  const itemsPerPageOldLogs = 10;

  // Calculate the index range for the current page
  const startIndexOldLogs = (currentPageOldLogs - 1) * itemsPerPageOldLogs;
  const endIndexOldLogs = startIndexOldLogs + itemsPerPageOldLogs;

  const [shows, setShow] = useState(false);
  const handleClose = () => setShow(false);

  var userId = JSON.parse(localStorage.getItem("userId"));

  const TerminateDialer = async () => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId }),
      };
      const response = await fetch(
        `${flask_url}/TerminateCompaign`,
        requestOptions
      );

      const responseData = await response.json();
      toast.success("Dialer Terminated");
    } catch (error) {
      toast.error("Something went wrong");
      console.error("Error during TerminateDialer:", error);
    }
  };

  const TerminateAiDialerHubSpot = async () => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ dialer_type: "csv/hubspot" }),
      };
      let response = {};
      if (selectedOption === "csv") {
        response = await fetch(
          `${flask_url}/Terminate_simultaneous_all_calls_hubspot`,
          requestOptions
        );
      } else {
        response = await fetch(
          `${flask_url}/Terminate_simultaneous_all_calls_csv`,
          requestOptions
        );
      }

      if (response.status === 200) {
        toast.success("Dialer Terminated");
      }
      if (response.status === 400) {
        // toast.error("Something went wrong");
      }

      const responseData = await response.json();
    } catch (error) {
      // toast.error("Something went wrong");
      console.error("Error during TerminateDialer:", error);
    }
  };

  const [hideLoader, setHideLoader] = useState(false);
  const [DialerTabs, setDialerTabs] = useState("currentdialer");

  const handleDialerTabs = (tab) => {
    setDialerTabs(tab);
  };

  // ----------------------------------------------------------------- Cards -------------------------------------------------------------------------------------

  const [aiDialler, setAiDialer] = useState([]);
  const [calls, setCalls] = useState([]);
  const [manualHubspotData, setManualCsvData] = useState([]);
  const [aiDialerHubspotCards, setAiDialerHubspotCards] = useState([]);

  // ---------------------------------------------------------------- Terminate ---------------------------------------------------------------------------------------

  const TerminateSingleCallCsv = async (call) => {
    // var call_sid = call["call_sid"];

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ call_sid: call }),
      };

      const response = await fetch(
        `${flask_url}/terminate_this_ai_call_hubspot`,
        requestOptions
      );

      const responseData = await response.json();
    } catch (error) {
      console.error("Error during Terminate Dialer:", error);
    }
  };

  // ------------------------------------------------------------------------------------------------------------------------------------------------------------------

  const [manualCsvRemaining, setMnualCsvRemaning] = useState([]);
  const [manualCsvDialed, setManualCsvDialed] = useState([]);

  const [manualHubspotRemaining, setMnualHubspotRemaning] = useState([]);
  const [manualHubspotDialed, setManualHubspotDialed] = useState([]);

  const [aiCsvRemaningCalls, setAiCsvRemaningCalls] = useState([]);
  const [aiCsvDialedCalls, setAiCsvDialedCalls] = useState([]);

  const [aiHubspotRemaningCalls, setAiHubspotRemaningCalls] = useState([]);
  const [aiHubspotDialedCalls, setAiHubspotDialedCalls] = useState([]);

  // -------------------------------------------------------------------------------------------------------------------------------------------------------------------
  useEffect(() => {
    const newSocket = new WebSocket("wss://gpd-production.onrender.com/ws");

    newSocket.onopen = (event) => {
      console.log("WebSocket connection opened:", event);
    };

    newSocket.onmessage = async (event) => {
      let data = await JSON.parse(event.data);
      console.log("Data 1:", data);
      console.log("Socket Data:", data);
      if (data.event === "agent_data_response") {
        setAiDialer(data?.data);
      }

      console.log("Data 2:", data);

      if (data.event === "manual_dialer_csv") {
        setCalls(data?.data);
      }

      console.log("Data 3:", data);

      if (data.event === "manual_dialer_csv_stats") {
        setMnualCsvRemaning(data?.data?.CustomersRemaining);
        setManualCsvDialed(data?.data?.CustomersCalled);
      }

      console.log("Data 4:", data);

      if (data.event === "manual_dialer_hubspot") {
        setManualCsvData(data?.data);
      }

      console.log("Data 5:", data);

      if (data.event === "manual_dialer_hubspot_stats") {
        // console.log("manual_dialer_hubspot_stats ------------------------------------------>", data);

        setMnualHubspotRemaning(data?.data?.CustomersRemaining);
        setManualHubspotDialed(data?.data?.CustomersCalled);
      }

      console.log("Data 6:", data);

      if (data.event === "send_agent_data_object_simultaneously_csv") {
        console.log(
          "send_agent_data_object_simultaneously_csv ----------------------------------",
          data
        );

        setAiDialer(data?.data);
      }

      console.log("Data 7:", data);

      if (data.event === "send_agent_data_object_simultaneously_csv_stats") {
        setAiCsvRemaningCalls(data?.data?.CustomersRemaining);
        setAiCsvDialedCalls(data?.data?.CustomersCalled);
      }

      console.log(
        "send_agent_data_object_simultaneously_hubspot ----------------------------------",
        data.data
      );
      if (data.data) {
        setLoading(false);
      }

      setAiDialerHubspotCards(data?.data);
      console.log("setAiDialerHubspot", data.data);

      console.log("data 9:", data);
      if (
        data.event === "send_agent_data_object_simultaneously_hubspot_stats"
      ) {
        setAiHubspotRemaningCalls(data?.data?.CustomersRemaining);
        setAiHubspotDialedCalls(data?.data?.CustomersCalled);
      }
    };

    return () => {
      newSocket.close();
    };
  }, []);

  const [runnigDialer, setRunningDialer] = useState(false);

  // ----------------------------------------------------------------- Do Not Touch -------------------------------------------------------------------------------------

  const handleManualCsv = () => {
    const userId = JSON.parse(localStorage.getItem("userId"));

    if (!userId) {
      toast.error("User Id Required");
      return;
    }

    if (customerData) {
      StartManualCsvDialer({
        agent_data: agentData,
        customers: customerData || [],
        user_id: userId,
      });
    } else {
      alert("Upload File First");
    }
  };

  const StartManualCsvDialer = async (data) => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      fetch(`${flask_url}/start-dialing-csv`, requestOptions)
        .then((response) => {
          response.json();
          setDataFromChild(true);
          setshowDialer(true);
        })
        .catch((error) => {
          console.error("Error during POST request:", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleManualHubspot = () => {
    const userId = JSON.parse(localStorage.getItem("userId"));

    if (!userId) {
      toast.error("User Id Required");
      return;
    }

    if (checkNumber) {
      StartManualHubspotDialer({
        agent_data: agentData,
        customers: hubspotDat || [],
        user_id: userId,
      });
    } else {
      alert("Number enter");
    }
  };

  const StartManualHubspotDialer = async (data) => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      fetch(`${flask_url}/start-dialing-Hubspot`, requestOptions)
        .then((response) => {
          setshowDialer(true);
          setHideLoader(false);
          response.json();
          setDataFromChild(true);
        })
        .catch((error) => {
          console.error("Error during POST request:", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const [showDailingStartBTN, setShowDailingStartBTN] = useState(false);
  const handleAilCsv = () => {
    const userId = JSON.parse(localStorage.getItem("userId"));

    if (!userId) {
      toast.error("User Id Required");
      return;
    }

    if (customerData) {
      StartAiCsvDialer({
        agent_id: "661fb4996c5d8aeca71a2f21",
        // dialer_type: "csv",
        customers: customerData || [],
        user_id: userId,
      });
    } else {
      alert("Upload File First");
    }
  };

  const StartAiCsvDialer = async (data) => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      fetch(`${flask_url}/outbound_call_simultaneously_csv`, requestOptions)
        .then((response) => {
          response.json();
        })
        .catch((error) => {
          console.error("Error during POST request:", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleAiHubspot = () => {
    const userId = JSON.parse(localStorage.getItem("userId"));

    if (!userId) {
      toast.error("User Id Required");
      return;
    }

    console.log(filteredData, "data");

    StartAiHubspotDialer({
      agentId: "661cf7e76c5d8aeca71a2e56",
      dialer_type: "hubspot",
      // customers: HubspotAgent || [],
      customers: filteredData,
      user_id: userId,
    });
    localStorage.setItem("DAILINGHUBSPOT", true);
    setshowDialer(true);
    setLoading(true);
  };

  const StartAiHubspotDialer = async (data) => {
    console.log(data, "Starting it now");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      fetch(`${flask_url}/outbound_call_simultaneously_hubspot`, requestOptions)
        .then((response) => {
          setshowDialer(true);
          setHideLoader(false);
          response.json();
        })
        .catch((error) => {
          toast.error(error.message);
          console.error("Error during POST request:", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // ---------------------------------------------------------------------------------------------------------------------------------------------------------------------

  const [filteredData, setfilteredData] = useState();


  useEffect(() => {
    let data = hubspotDat;

    console.log("selectedLead_status", selectedLead_status);
    // Filter by city
    if (selectedValue !== "All") {
      data = data.filter((item) => item.properties.city === selectedValue);
    }

    // Filter by lead status
    if (selectedLead_status !== "All") {
      data = data.filter(
        (item) => item.properties.hs_lead_status === selectedLead_status
      );
    }

    // Filter by lead stage
    if (selectedLead_Stage !== "All") {
      data = data.filter(
        (item) => item.properties.lead_stage === selectedLead_Stage
      );
    }

    // Filter by property type
    if (selectedpropertytype !== "All") {
      data = data.filter(
        (item) => item.properties.propertytype === selectedpropertytype
      );
    }

    // Add agentId to the filtered data

    if (chooseAgent.length <= 0) {
      // If not, fetch agents.
      fechAgents();
    }
    console.log(chooseAgent);
    const newStuff = data.map((item) => ({
      ...item,
      agentId: chooseAgent[0]?._id,
    }));

    setfilteredData(newStuff);

    if (!newStuff) return;



    if(find === false)
      {
        setLoading(true);
      }


      if (chooseAgent.length <= 0) {
        // If not, fetch agents.
        fechAgents();
      }

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    setCurrentData(newStuff.slice(startIndex, endIndex));
  }, [
    selectedValue,
    selectedLead_status,
    selectedLead_Stage,
    selectedpropertytype,
    hubspotDat,
    chooseAgent,
    currentPage,
  ]);

  useEffect(() => {
    if (!currentData) {
      return;
    }
    if (currentData.length > 0) {
      setLoading(false);
    }
  }, [currentData]);

  useEffect(() => {
    const cities = new Set();
    const lead = new Set();
    const Lead_Stage = new Set();
    const propertytype = new Set();
    // Handle potential errors and empty data
    hubspotDat?.forEach((item) => {
      if (item.properties.city) {
        cities.add(item.properties.city); // Add city to the set (ensures uniqueness)
      }

      if (item.properties.hs_lead_status) {
        lead.add(item.properties.hs_lead_status); // Add lead status to the set (ensures uniqueness)
      }

      if (item.properties.hs_lead_status) {
        Lead_Stage.add(item.properties.lead_stage); // Add lead status to the set (ensures uniqueness)
      }
      if (item.properties.hs_lead_status) {
        propertytype.add(item.properties.propertytype); // Add lead status to the set (ensures uniqueness)
      }
    });

    cities.add("All");
    lead.add("All");
    Lead_Stage.add("All");
    propertytype.add("All");
    setUniqueCities(Array.from(cities));
    setLead_status(Array.from(lead));
    setLead_Stage(Array.from(Lead_Stage));
    setpropertytype(Array.from(propertytype));

    // Convert set to array and update state
  }, [hubspotDat, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedValue]);

 
  // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

  const handleSaveEMailAndSave = () => {
    const token = JSON.parse(localStorage.getItem("bearerToken"));
    let data = JSON.stringify({
      event_email_subject: Subject,
      event_email_description: Message,
      Sms_Message: SMS,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/customer/updateAgent/${SelectedValueEmail}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        toast.success("Agent updated successfully");
        setMessage("");
        setSMS("");
        setSubject("");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEventssave = () => {
    const token = JSON.parse(localStorage.getItem("bearerToken"));
    if(!SelectedValueEmail) {
      toast.error("Please select an agent to update");
      return;
    }
   

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/customer/updateAgent/${SelectedValueEmail}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        Candelyapitoken: tokenID,
        candelyEventtypeuri: SelectedValueEvents,
      },
    };

    console.log(config );

    axios
      .request(config)
      .then((response) => {
        toast.success("Agent updated successfully");
      })
      .catch((error) => {
        console.log(error);
      });
  };


  const handleSubject = (event) => {
    setSubject(event.target.value);
  };

  const handleMessage = (event) => {
    setMessage(event.target.value);
  };

  const handleSMS = (event) => {
    setSMS(event.target.value);
  };
  const handleToken = (event) => {
    setToken(event.target.value);
  };
  return (
    <>
      <div className="setOverFlow">
        {!dataFromChild && !showDialer ? (
          <div>
            <div className="dialer-main-container">
              <div className="topBar">
                <div className="bruceDiv">
                  <img
                    className="bruceImg"
                    src="/images/Dashboard/bruceImg.png"
                    alt="..."
                  />
                  <h3>Bruce Wayne</h3>
                </div>
              </div>

              {showMannudalDialer === "manual" && (
                <div div className="">
                  <div className="dialerInputs-container">
                    <div className="dial-opt-div d-flex justify-content-between">
                      <h3>Add Number For Manual Dialing</h3>
                      <div className="pr-4">
                        <button
                          className={`themebtn-1 mr-3 ${
                            showMannudalDialer === "aidilaer" ? "addBorder" : ""
                          }`}
                          onClick={() => handleShowMannudalDialer("aidilaer")}
                        >
                          AI Dialer
                        </button>

                        <button
                          className={`themebtn-1 mr-3 ${
                            showMannudalDialer === "setEmail" ? "addBorder" : ""
                          }`}
                          onClick={() => handleShowMannudalDialer("setEmail")}
                        >
                          Set Email
                        </button>
                        <button
                        className={`themebtn-1 mr-3 ${
                          showMannudalDialer === "Calendly" ? "addBorder" : ""
                        }`}
                        onClick={() => handleShowMannudalDialer("Calendly")}
                      >
                        Set Calendly
                      </button>
                      </div>
                    </div>

                    <span className="pt-3">
                      {agentData.map((agent, index) => (
                        <div className="for-mobile-screen" key={index}>
                          <label htmlFor={`agent-${index + 1}`}>
                            Agent {index + 1}: &nbsp;
                          </label>
                          <div>
                            <input
                              type="text"
                              value={agent.name}
                              placeholder="Name"
                              style={{ marginBottom: "10px", width: "100%" }}
                              onChange={(e) =>
                                handleInputChange(e.target.value, index, "name")
                              }
                            />
                            <PhoneInput
                              international
                              countryCallingCodeEditable={false}
                              defaultCountry="CA"
                              value={agent.number}
                              onChange={(value) =>
                                handleInputChange(value, index, "number")
                              }
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      ))}
                    </span>
                  </div>

                  <div className="dialer-radios-box d-flex justify-content-between align-itms-center">
                    <div className="">
                      <label className="mr-4">
                        <input
                          type="radio"
                          value="concrete"
                          checked={selectedOption === "concrete"}
                          onChange={handleRadioChange}
                        />
                        <span>CSV</span>
                      </label>

                      <label>
                        <input
                          type="radio"
                          value="csv"
                          checked={selectedOption === "csv"}
                          onChange={handleRadioChange}
                        />
                        <span>Hub Spot</span>
                      </label>
                    </div>

                    {selectedOption === "concrete" && (
                      <button
                        className="themebtn-1 mt-2 px-4"
                        onClick={() => {
                          handleManualCsv();
                        }}
                      >
                        Start Dailing
                      </button>
                    )}
                  </div>
                  {selectedOption === "concrete" && (
                    <>
                      <CsvUploader
                        setCsvData={setCsvData}
                        customerData={customerData}
                        setCustomerData={setCustomerData}
                        agentNumbers={agentData}
                        getLoader={getLoader}
                        checkNumber={true}
                      />
                      {csvData && (
                        <div>
                          <h5>CSV File Contents:</h5>
                          <table class="contact-table">
                            <thead>
                              <tr>
                                {csvData[0].map((header, index) => (
                                  <th key={index}>{header.trim()}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {csvData.slice(1).map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell.trim()}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </>
                  )}

                  {selectedOption === "csv" && (
                    <>
                      <div className="start d-flex justify-content-end align-items-end">
                        <button
                          className="themebtn-1 mt-2 px-4"
                          onClick={() => {
                            handleManualHubspot();
                          }}
                        >
                          Start Dialing
                        </button>
                      </div>
                      <table className="contact-table">
                        <div className="table-outer">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>email</th>
                              <th>Phone Number</th>
                              <th>Contact Owner</th>
                              <th>Lead Status</th>
                              <th>Type of Contact</th>
                              <th>Property Name</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentData.map((item) => (
                              <tr key={item.id}>
                                {/* <td>{item?.properties?.firstname}</td>
                            <td>{item?.properties?.email}</td> */}

                                <td>
                                  {item?.properties?.firstname}{" "}
                                  {item?.properties?.lastname}
                                </td>
                                <td>{item?.properties?.email}</td>
                                <td>{item?.properties?.phone}</td>
                                <td>{item?.properties?.hubspot_owner_id}</td>
                                <td>{item?.properties?.hs_lead_status}</td>
                                <td>{item?.properties?.type_of_list}</td>
                                <td>{item?.properties?.property_name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </div>
                      </table>
                      {/* Pagination controls */}
                      <div className="pagination-container">
                        <button
                          className="themebtn-1"
                          onClick={() =>
                            setCurrentPage((prevPage) =>
                              Math.max(prevPage - 1, 1)
                            )
                          }
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                        <span>{currentPage}</span>
                        <button
                          className="themebtn-1"
                          onClick={() =>
                            setCurrentPage((prevPage) =>
                              Math.min(
                                prevPage + 1,
                                Math.ceil(HubspotAgent.length / itemsPerPage)
                              )
                            )
                          }
                          disabled={
                            currentPage ===
                            Math.ceil(HubspotAgent.length / itemsPerPage)
                          }
                        >
                          Next
                        </button>
                      </div>
                    </>
                  )}
                </div>
              )}

              {showMannudalDialer === "aidilaer" && (
                <div className="">
                  <div className="dialerInputs-container">
                    <div className="dial-opt-div d-flex justify-content-between">
                      <h3>AI Dialer</h3>
                      <div className="pr-4">
                        {
                          //   <button
                          //   className={`themebtn-1 mr-3 ${showMannudalDialer === "manual" ? "addBorder" : ""
                          //     }`}
                          //   onClick={() => handleShowMannudalDialer("manual")}
                          // >
                          //   Manual Dialer
                          // </button>
                        }

                        <button
                          className={`themebtn-1 mr-3 ${
                            showMannudalDialer === "aidilaer" ? "addBorder" : ""
                          }`}
                          onClick={() => handleShowMannudalDialer("aidilaer")}
                        >
                          AI Dialer
                        </button>
                        {/* <button
                          className={`themebtn-1 mr-3 ${
                            showMannudalDialer === "oldlogs" ? "addBorder" : ""
                          }`}
                          onClick={() => handleShowMannudalDialer("oldlogs")}
                        >
                          Old Logs
                        </button>*/}
                        <button
                          className={`themebtn-1 mr-3 ${
                            showMannudalDialer === "setEmail" ? "addBorder" : ""
                          }`}
                          onClick={() => handleShowMannudalDialer("setEmail")}
                        >
                          Set Email
                        </button>
                        <button
                        className={`themebtn-1 mr-3 ${
                          showMannudalDialer === "Calendly" ? "addBorder" : ""
                        }`}
                        onClick={() => handleShowMannudalDialer("Calendly")}
                      >
                        Set Calendly
                      </button>
                      </div>
                    </div>
                  </div>
                  <div className="align-div d-flex justify-content-between align-items-center gap-4">
                    <div className="ai-dial d-flex flex-column gap-4">
                      <div className="dialer-radios-box">
                        <label className="mr-3">
                          <input
                            type="radio"
                            value="concrete"
                            checked={selectedOption === "concrete"}
                            onChange={handleRadioChange}
                          />
                          <span>CSV</span>
                        </label>

                        <label>
                          <input
                            type="radio"
                            value="csv"
                            checked={selectedOption === "csv"}
                            onChange={handleRadioChange}
                          />
                          <span>Hub Spot</span>
                        </label>
                      </div>

                      {selectedOption === "csv" && (
                        <div style={{ display: "flex" }}>
                          <div className="dialer-radios-box">
                            <p style={styles.cityLabel}> City</p>
                            <select
                              value={selectedValue}
                              onChange={handleChange}
                              style={{ width: "400px" }}
                            >
                              {uniqueCities.length > 0 &&
                                uniqueCities.map((city, index) => (
                                  <option key={index} value={city}>
                                    {city}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="dialer-radios-box">
                            <p style={styles.cityLabel}> Lead Status </p>
                            <select
                              value={selectedLead_status}
                              onChange={handleChangeLead_status}
                              style={{ width: "200px" }}
                            >
                              {Lead_status.length > 0 &&
                                Lead_status.map((city, index) => (
                                  <option key={index} value={city}>
                                    {city}
                                  </option>
                                ))}
                            </select>
                          </div>

                          <div className="dialer-radios-box">
                            <p style={styles.cityLabel}> Property Type </p>
                            <select
                              value={selectedpropertytype}
                              onChange={handleChangeproperty}
                              style={{ width: "200px" }}
                            >
                              {propertytype.length > 0 &&
                                propertytype.map((city, index) => (
                                  <option key={index} value={city}>
                                    {city}
                                  </option>
                                ))}
                            </select>
                          </div>

                          <div className="dialer-radios-box">
                            <p style={styles.cityLabel}> Lead Stage </p>
                            <select
                              value={selectedLead_Stage}
                              onChange={handleChangeLeadStage}
                              style={{ width: "200px" }}
                            >
                              {Lead_Stage.length > 0 &&
                                Lead_Stage.map((city, index) => (
                                  <option key={index} value={city}>
                                    {city}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      )}
                    </div>

                    {selectedOption === "concrete" && (
                      <button
                        className="themebtn-1 mr-5"
                        onClick={() => {
                          handleAilCsv();
                          if (customerData) {
                            setshowDialer(true);
                          }
                        }}
                      >
                        Start Dialing
                      </button>
                    )}
                    {selectedOption === "csv" && showDailingStartBTN && (
                      <button
                        className="themebtn-1 mt-2 px-4"
                        // onClick={handleAiCall}
                        onClick={() => {
                          handleAiHubspot();
                          //  setshowDialer(true);
                        }}
                      >
                        Start Dialing
                      </button>
                    )}
                  </div>

                  {selectedOption === "concrete" && (
                    // AI DIALER
                    // <CsvUploader
                    //   setCsvData={setCsvData}
                    //   customerData={customerData}
                    //   setCustomerData={setCustomerData}
                    //   agentNumbers={agentData}
                    //   getLoader={getLoader}
                    //   checkNumber={true}
                    // />
                    <>
                      <CsvUploader
                        setCsvData={setCsvData}
                        customerData={customerData}
                        setCustomerData={setCustomerData}
                        agentNumbers={agentData}
                        getLoader={getLoader}
                        checkNumber={true}
                      />
                      {csvData && (
                        <div>
                          <h5>CSV File Contents:</h5>
                          <table class="contact-table">
                            <thead>
                              <tr>
                                {csvData[0].map((header, index) => (
                                  <th key={index}>{header.trim()}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {csvData.slice(1).map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell.trim()}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </>
                  )}

                  {selectedOption === "csv" && (
                    <>
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "60vh",
                          }}
                        >
                          <div className="loader"></div>
                        </div>
                      ) : (
                        <>
                          <div className="d-flex justify-content-end align-items-end"></div>
                          <table className="contact-table">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>email</th>
                                <th>Phone Number</th>
                                <th>Contact Owner</th>
                                <th>Lead Status</th>
                                <th>Type of Contact</th>
                                <th>Property type</th>
                                <th>Agent</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentData && currentData.length > 0 ? (
                                currentData.map((item, index) => (
                                  <tr key={item.id}>
                                    <td>
                                      {item?.properties?.firstname}{" "}
                                      {item?.properties?.lastname}
                                    </td>
                                    <td>{item?.properties?.email}</td>
                                    <td>{item?.properties?.phone}</td>
                                    <td>
                                      {item?.properties?.hubspot_owner_id}
                                    </td>
                                    <td>{item?.properties?.hs_lead_status}</td>
                                    <td>{item?.properties?.type_of_list}</td>
                                    <td>{item?.properties?.propertytype}</td>
                                    <td>
                                      <select
                                        className="form-select form-select-sm"
                                        aria-label=".form-select-sm example"
                                        onChange={(e) =>
                                          handleSelectChange(
                                            e,
                                            chooseAgent[0]?._id,
                                            index
                                          )
                                        }
                                        value={
                                          filteredData[index]?.agentId ||
                                          chooseAgent[0]?._id
                                        }
                                      >
                                        {Array.isArray(chooseAgent) &&
                                          chooseAgent.length !== 0 &&
                                          chooseAgent.map((agent) => (
                                            <option
                                              key={agent._id}
                                              value={agent._id}
                                            >
                                              {agent?.agentName}
                                            </option>
                                          ))}
                                      </select>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="8" className="text-center">
                                    No data found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                          {/* Pagination controls */}
                          <div className="pagination-container">
                            <button
                              className="themebtn-1"
                              onClick={() =>
                                setCurrentPage((prevPage) =>
                                  Math.max(prevPage - 1, 1)
                                )
                              }
                              disabled={currentPage === 1}
                            >
                              Previous
                            </button>
                            <span>{currentPage}</span>
                            <button
                              className="themebtn-1"
                              onClick={() =>
                                setCurrentPage((prevPage) =>
                                  Math.min(
                                    prevPage + 1,
                                    Math.max(
                                      1, // Ensure the page doesn't go below 1
                                      Math.ceil(
                                        selectedValue === "All" &&
                                          selectedpropertytype === "All" &&
                                          selectedLead_Stage === "All" &&
                                          selectedLead_status === "All"
                                          ? hubspotDat.length / itemsPerPage
                                          : filteredData &&
                                            filteredData.length > 0
                                          ? filteredData.length / itemsPerPage
                                          : 0 // Check if filteredData is not null or empty
                                      )
                                    )
                                  )
                                )
                              }
                              disabled={
                                currentPage ===
                                Math.ceil(
                                  selectedValue === "All" &&
                                    selectedpropertytype === "All" &&
                                    selectedLead_Stage === "All" &&
                                    selectedLead_status === "All"
                                    ? hubspotDat.length / itemsPerPage
                                    : filteredData?.length / itemsPerPage
                                )
                              }
                            >
                              Next
                            </button>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              )}

              {showMannudalDialer === "oldlogs" && (
                <div className="">
                  <div className="dialerInputs-container">
                    <div className="dial-opt-div d-flex justify-content-between">
                      <h3>Old Logs</h3>
                      <div className="pr-4">
                        {
                          //   <button
                          //   className={`themebtn-1 mr-3 ${showMannudalDialer === "manual" ? "addBorder" : ""
                          //     }`}
                          //   onClick={() => handleShowMannudalDialer("manual")}
                          // >
                          //   Manual Dialer
                          // </button>
                        }

                        <button
                          className={`themebtn-1 mr-3 ${
                            showMannudalDialer === "aidilaer" ? "addBorder" : ""
                          }`}
                          onClick={() => handleShowMannudalDialer("aidilaer")}
                        >
                          AI Dialer
                        </button>
                        {/*
                          <button
                          className={`themebtn-1 mr-3 ${
                            showMannudalDialer === "oldlogs" ? "addBorder" : ""
                          }`}
                          onClick={() => handleShowMannudalDialer("oldlogs")}
                        >
                          Old Logs
                        </button>
                      */}
                        <button
                          className={`themebtn-1 mr-3 ${
                            showMannudalDialer === "setEmail" ? "addBorder" : ""
                          }`}
                          onClick={() => handleShowMannudalDialer("setEmail")}
                        >
                          Set Email
                        </button>
                        <button
                        className={`themebtn-1 mr-3 ${
                          showMannudalDialer === "Calendly" ? "addBorder" : ""
                        }`}
                        onClick={() => handleShowMannudalDialer("Calendly")}
                      >
                        Set Calendly
                      </button>
                      </div>
                    </div>
                  </div>

                  {/* <table class="contact-table">
                  <thead>
                    <tr>
                      <th>Customer Name</th>
                      <th>Service Type</th>
                      <th>Customer Phone Number</th>
                      <th>Agent Phone Number</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userLogs.length != 0 ? (
                      userLogs.map((item) => {
                        return (
                          <tr>
                            <td>{item?.dialerdata?.CustomerName}</td>
                            <td>{item?.dialerdata?.ServiceType}</td>
                            <td>{item?.dialerdata?.PhoneNumber}</td>
                            <td>{item?.dialerdata?.agent_number}</td>
                            <td>{item?.dialerdata?.call_status}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </tbody>
                </table> */}

                  <table className="contact-table">
                    <div className="table-outer">
                      <thead>
                        <tr>
                          <th>Customer Name</th>
                          <th>Service Type</th>
                          <th>Customer Phone Number</th>
                          <th>Agent Phone Number</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userLogs.length !== 0 ? (
                          userLogs
                            .slice(startIndexOldLogs, endIndexOldLogs)
                            .map((item) => {
                              return (
                                <tr key={item.id}>
                                  <td>{item?.dialerdata?.CustomerName}</td>
                                  <td>{item?.dialerdata?.ServiceType}</td>
                                  <td>{item?.dialerdata?.PhoneNumber}</td>
                                  <td>{item?.dialerdata?.agent_number}</td>
                                  <td>{item?.dialerdata?.call_status}</td>
                                </tr>
                              );
                            })
                        ) : (
                          <tr>
                            <td colSpan="5">No data available</td>
                          </tr>
                        )}
                      </tbody>
                    </div>
                  </table>

                  {/* Pagination controls */}
                  <div className="pagination-container">
                    <button
                      className="themebtn-1"
                      onClick={() =>
                        setCurrentPageOldLogs((prevPage) =>
                          Math.max(prevPage - 1, 1)
                        )
                      }
                      disabled={currentPageOldLogs === 1}
                    >
                      Previous
                    </button>
                    <span>{currentPageOldLogs}</span>
                    <button
                      className="themebtn-1"
                      onClick={() =>
                        setCurrentPageOldLogs((prevPage) =>
                          Math.min(
                            prevPage + 1,
                            Math.ceil(userLogs.length / itemsPerPageOldLogs)
                          )
                        )
                      }
                      disabled={
                        currentPageOldLogs ===
                        Math.ceil(userLogs.length / itemsPerPageOldLogs)
                      }
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}

              {showMannudalDialer === "setEmail" && (
                <div div className="">
                  <div className="dialerInputs-container">
                    <div className="dial-opt-div d-flex justify-content-between">
                      <h3>Set Email</h3>
                      <div className="pr-4">
                        <button
                          className={`themebtn-1 mr-3 ${
                            showMannudalDialer === "aidilaer" ? "addBorder" : ""
                          }`}
                          onClick={() => handleShowMannudalDialer("aidilaer")}
                        >
                          AI Dialer
                        </button>

                        <button
                          className={`themebtn-1 mr-3 ${
                            showMannudalDialer === "setEmail" ? "addBorder" : ""
                          }`}
                          onClick={() => handleShowMannudalDialer("setEmail")}
                        >
                          Set Email
                        </button>
                        <button
                        className={`themebtn-1 mr-3 ${
                          showMannudalDialer === "Calendly" ? "addBorder" : ""
                        }`}
                        onClick={() => handleShowMannudalDialer("Calendly")}
                      >
                        Set Calendly
                      </button>
                      </div>
                    </div>
                  </div>
                  <div className="setEmail-container">
                    <div className="setEmail-left-box">
                      <select
                        class="form-select form-select-sm"
                        aria-label=".form-select-sm example"
                        onChange={(e) => handleSelectChangeEmail(e)}
                        value={SelectedValueEmail}
                      >
                        {Array.isArray(chooseAgent) &&
                          chooseAgent.length !== 0 &&
                          chooseAgent.map((agent) => {
                            return (
                              <option
                                selected
                                key={agent._id}
                                value={agent._id}
                              >
                                {agent?.agentName}
                              </option>
                            );
                          })}
                      </select>
                      <label htmlFor="">Subject</label>
                      <input
                        type="text"
                        value={Subject}
                        placeholder="Subject"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={handleSubject}
                      />
                      <br />
                      <label htmlFor="">Message</label>
                      <textarea
                        type="text"
                        value={Message}
                        placeholder="Message"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={handleMessage}
                      />
                    </div>

                    <h3>SMS Setting</h3>
                    <div className="setEmail-left-box">
                      <label htmlFor="">Message</label>
                      <textarea
                        type="text"
                        value={SMS}
                        placeholder="Message"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={handleSMS}
                      />
                    </div>
                    <div>
                      <button
                        class="themebtn-1 mr-3 addBorder"
                        onClick={() => handleSaveEMailAndSave()}
                      >
                        Save{" "}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {showMannudalDialer === "Calendly" && (
                <div div className="">
                  <div className="dialerInputs-container">
                    <div className="dial-opt-div d-flex justify-content-between">
                      <h3>Set Email</h3>
                      <div className="pr-4">
                        <button
                          className={`themebtn-1 mr-3 ${
                            showMannudalDialer === "aidilaer" ? "addBorder" : ""
                          }`}
                          onClick={() => handleShowMannudalDialer("aidilaer")}
                        >
                          AI Dialer
                        </button>

                        <button
                          className={`themebtn-1 mr-3 ${
                            showMannudalDialer === "setEmail" ? "addBorder" : ""
                          }`}
                          onClick={() => handleShowMannudalDialer("setEmail")}
                        >
                          Set Email
                        </button>
                        <button
                        className={`themebtn-1 mr-3 ${
                          showMannudalDialer === "Calendly" ? "addBorder" : ""
                        }`}
                        onClick={() => handleShowMannudalDialer("Calendly")}
                      >
                        Set Calendly
                      </button>
                      </div>
                    </div>
                  </div>
                  <div className="setEmail-container">
                    <div className="setEmail-left-box">
                    <label htmlFor="">Token</label>
                      <textarea
                        type="text"
                        value={Message}
                        placeholder="Message"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={handleToken}
                      /> 
                      <div>
                      <button class="themebtn-1 mr-3 addBorder" style={{marginBottom:10}} onClick={getUserUri}>Select event Types</button>
                      </div>
                      <label htmlFor="">Agent</label>
                      <select
                      class="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                      onChange={(e) => handleSelectChangeEmail(e)}
                      value={SelectedValueEmail}
                    >
                      {Array.isArray(chooseAgent) &&
                        chooseAgent.length !== 0 &&
                        chooseAgent.map((agent) => {
                          return (
                            <option
                              selected
                              key={agent._id}
                              value={agent._id}
                            >
                              {agent?.agentName}
                            </option>
                          );
                        })}
                    </select>
                    <label htmlFor="">Event</label>
                      <select
                        class="form-select form-select-sm"
                        aria-label=".form-select-sm example"
                        onChange={(e) => handleSelectChangeEvents(e)}
                        value={SelectedValueEvents}
                      >
                        {Array.isArray(eventTypes) &&
                          eventTypes.length !== 0 &&
                          eventTypes.map((agent,index) => {
                            return (
                              <option
                                selected
                                key={agent._id}
                                value={agent.uri}
                              >
                                {agent?.name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    <div>
                      <button
                        class="themebtn-1 mr-3 addBorder"
                        onClick={() => handleEventssave()}
                      >
                        Save{" "}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <LoaderScreen
            hideLoader={hideLoader}
            setHideLoader={setHideLoader}
            customerData={customerData}
            setCustomerData={setCustomerData}
            agentData={agentData}
            getLoader={getLoader}
            showDialer={showDialer}
            setshowDialer={setshowDialer}
            runnigDialer={runnigDialer}
            setRunningDialer={setRunningDialer}
          />
        )}
        {showDialer && (
          <>
            <div className="AgentScreenWrapper">
              <div className="top-div d-flex justify-content-between">
                <h2>Running Dialer</h2>

                <>
                  <button
                    className="theme-1"
                    onClick={TerminateAiDialerHubSpot}
                  >
                    Terminates
                  </button>
                  <button
                    className="theme-1"
                    onClick={() => {
                      TerminateAiDialerHubSpot();
                      localStorage.setItem("DAILINGHUBSPOT", "");
                      setshowDialer(false);
                    }}
                  >
                    back
                  </button>
                </>
              </div>
              {/* Dialer Tabs */}
              <div className="DialerTabs d-flex justify-content-end gap-4 pt-2 pr-4">
                <button
                  className="themebtn-1"
                  onClick={() => handleDialerTabs("currentdialer")}
                >
                  Current Dialer
                </button>
                <button
                  className="themebtn-1"
                  onClick={() => handleDialerTabs("inqueue")}
                >
                  In Queue
                </button>
                <button
                  className="themebtn-1"
                  onClick={() => handleDialerTabs("dialed")}
                >
                  Dialed
                </button>
              </div>
              {/* Dialer Tabs */}
              {DialerTabs === "currentdialer" && (
                <div className="agentGrid">
                  {calls?.length !== 0 ? (
                    calls
                      ?.slice()
                      ?.reverse()
                      ?.map((item) => {
                        return (
                          <>
                            <div className="dialer-callingOption-box">
                              <img
                                src={personCalling}
                                className="runningDialer-Calling-Img"
                                alt=""
                              />
                              <h6>
                                Agent Name : <span> {item?.agent_name} </span>
                              </h6>
                              <h6>
                                Agent Number:{" "}
                                <span> {item?.agent_number} </span>
                              </h6>
                              <h6>
                                Client Name:{" "}
                                <span>
                                  {" "}
                                  {item?.Customer.properties.firstname}{" "}
                                  {item?.Customer.properties.lastname}{" "}
                                </span>
                              </h6>
                              <h6>
                                Email:{" "}
                                <span> {item?.Customer.properties.email} </span>
                              </h6>
                              <h6>
                                Client Number:{" "}
                                <span> {item?.PhoneNumber} </span>
                              </h6>

                              <p className="statusCall">
                                Status: <span> {item.call_status}</span>
                              </p>
                              <p className="statusCall">
                                Duration:{" "}
                                <span>
                                  {" "}
                                  {formatSecondsToTime(item?.call_duration)}
                                </span>
                              </p>
                              {item?.call_status === "queued" ||
                              item?.call_status === "initiated" ||
                              item?.call_status === "ringing" ||
                              item?.call_status === "answered" ||
                              item?.call_status === "in-progress" ||
                              item?.call_status === "Connected to Agent" ||
                              item?.call_status === "Connecting to Agent" ||
                              item?.call_status === "Ringing to Agent" ? (
                                <button
                                  onClick={() => {
                                    TerminateSingleCallCsv(item);
                                  }}
                                  className="termBtn mt-3"
                                >
                                  Terminate
                                </button>
                              ) : (
                                <></>
                              )}
                            </div>
                          </>
                        );
                      })
                  ) : (
                    <></>
                  )}

                  {manualHubspotData.length !== 0 ? (
                    manualHubspotData
                      ?.slice()
                      ?.reverse()
                      ?.map((item) => {
                        return (
                          <>
                            <div className="dialer-callingOption-box">
                              <img
                                src={personCalling}
                                className="runningDialer-Calling-Img"
                                alt=""
                              />
                              <h6>
                                Agent Name : <span> {item?.agent_name} </span>
                              </h6>
                              <h6>
                                Agent Number:{" "}
                                <span> {item?.agent_number} </span>
                              </h6>
                              <h6>
                                Client Name:{" "}
                                <span>
                                  {" "}
                                  {item?.Customer.properties.firstname}{" "}
                                  {item?.Customer.properties.lastname}{" "}
                                </span>
                              </h6>
                              <h6>
                                Email:{" "}
                                <span> {item?.Customer.properties.email} </span>
                              </h6>
                              <h6>
                                Client Number:{" "}
                                <span> {item?.PhoneNumber} </span>
                              </h6>

                              <p className="statusCall">
                                Status: <span> {item.call_status}</span>
                              </p>
                              <p className="statusCall">
                                Duration:{" "}
                                <span>
                                  {" "}
                                  {formatSecondsToTime(item?.call_duration)}
                                </span>
                              </p>
                              {item?.call_status === "queued" ||
                              item?.call_status === "initiated" ||
                              item?.call_status === "ringing" ||
                              item?.call_status === "answered" ||
                              item?.call_status === "in-progress" ||
                              item?.call_status === "Connected to Agent" ||
                              item?.call_status === "Connecting to Agent" ||
                              item?.call_status === "Ringing to Agent" ? (
                                <button
                                  onClick={() => {
                                    TerminateSingleCallCsv(item);
                                  }}
                                  className="termBtn mt-3"
                                >
                                  Terminate
                                </button>
                              ) : (
                                <></>
                              )}
                            </div>
                          </>
                        );
                      })
                  ) : (
                    <></>
                  )}

                  {aiDialler?.length !== 0 ? (
                    aiDialler?.reverse()?.map((item) => {
                      return (
                        <>
                          <div className="dialer-callingOption-box">
                            <img
                              src={personCalling}
                              className="runningDialer-Calling-Img"
                              alt=""
                            />
                            <h6>
                              Client Name :{" "}
                              <span> {item?.customer.CustomerName} </span>
                            </h6>

                            <h6>
                              Client Number:{" "}
                              <span> {item?.customer.PhoneNumber} </span>
                            </h6>

                            <p className="statusCall">
                              Status: <span> {item?.Call_status}</span>
                            </p>
                            {
                              <p className="statusCall">
                                Duration:{" "}
                                <span>
                                  {" "}
                                  {formatSecondsToTime(item?.Call_Duration)}
                                </span>
                              </p>
                            }
                            {[
                              "queued",
                              "initiated",
                              "ringing",
                              "answered",
                              "in-progress",
                              "Connected to Agent",
                              "Connecting to Agent",
                              "Ringing to Agent",
                            ].includes(item?.Call_status) && (
                              <button
                                onClick={() => {
                                  TerminateSingleCallCsv(item?.Call_sid);
                                }}
                                className="termBtn mt-3"
                              >
                                Terminate
                              </button>
                            )}
                          </div>
                        </>
                      );
                    })
                  ) : (
                    <></>
                  )}

                  {Array.isArray(aiDialerHubspotCards) ? (
                    aiDialerHubspotCards
                      ?.slice()
                      ?.reverse()
                      ?.map((item) => {
                        return (
                          <>
                            <div className="dialer-callingOption-box">
                              <img
                                src={personCalling}
                                className="runningDialer-Calling-Img"
                                alt=""
                              />
                              <h6>
                                Agent Name : <span> {item.agent_name} </span>
                              </h6>

                              <h6>
                                Client Name:{" "}
                                <span>
                                  {" "}
                                  {item?.Firstname} {item?.Lastname}{" "}
                                </span>
                              </h6>

                              <h6>
                                Client Number:{" "}
                                <span> {item?.Phone_number} </span>
                              </h6>

                              <p className="statusCall">
                                Status: <span> {item.Call_status}</span>
                              </p>
                              <p className="statusCall">
                                Duration:{" "}
                                <span>
                                  {" "}
                                  {formatSecondsToTime(item?.Call_Duration)}
                                </span>
                              </p>
                              <p className="statusCall">
                                Lead_status: <span> {item.Lead_status}</span>
                              </p>

                              {[
                                "queued",
                                "initiated",
                                "ringing",
                                "answered",
                                "in-progress",
                                "Connected to Agent",
                                "Connecting to Agent",
                                "Ringing to Agent",
                              ].includes(item?.Call_status) && (
                                <button
                                  onClick={() => {
                                    TerminateSingleCallCsv(item?.Call_sid);
                                  }}
                                  className="termBtn mt-3"
                                >
                                  Terminate
                                </button>
                              )}
                            </div>
                          </>
                        );
                      })
                  ) : (
                    <></>
                  )}
                </div>
              )}

              {DialerTabs === "inqueue" && (
                <>
                  {manualCsvRemaining && manualCsvRemaining != 0 && (
                    <TableCSV data={manualCsvRemaining} columns={columnsCsv} />
                  )}
                  {manualHubspotRemaining && manualHubspotRemaining != 0 && (
                    <TableHubspot
                      data={manualHubspotRemaining}
                      columns={columnsHubspot}
                    />
                  )}

                  {aiCsvRemaningCalls && aiCsvRemaningCalls != 0 && (
                    <TableCSV data={aiCsvRemaningCalls} columns={columnsCsv} />
                  )}
                  {aiHubspotRemaningCalls && aiHubspotRemaningCalls != 0 && (
                    <TableHubspot
                      data={aiHubspotRemaningCalls}
                      columns={columnsHubspot}
                    />
                  )}
                </>
              )}

              {DialerTabs === "dialed" && (
                <>
                  {manualCsvDialed && manualCsvDialed != 0 && (
                    <TableCSV data={manualCsvDialed} columns={columnsCsv} />
                  )}
                  {manualHubspotDialed && manualHubspotDialed != 0 && (
                    <TableHubspot
                      data={manualHubspotDialed}
                      columns={columnsHubspot}
                    />
                  )}

                  {aiCsvDialedCalls && aiCsvDialedCalls != 0 && (
                    <TableCSV data={aiCsvDialedCalls} columns={columnsCsv} />
                  )}
                  {aiHubspotDialedCalls && aiHubspotDialedCalls != 0 && (
                    <TableHubspot
                      data={aiHubspotDialedCalls}
                      columns={columnsHubspot}
                    />
                  )}
                </>
              )}

              {/* Dialer Tabs */}
              <Modal show={shows} onHide={handleClose} className="agentModal">
                <Modal.Header closeButton>
                  <Modal.Title className="titleOfModal">
                    Customer Response Type
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBody">
                  <div className="choosingCase">
                    <p>Concrete Restoration</p>
                  </div>
                  <div className="choosingCase">
                    <p>Stucco Repair</p>
                  </div>
                  <div className="choosingCase">
                    <p>Painting</p>
                  </div>
                </Modal.Body>
                {/* <Modal.Footer>
              <Button className="save-btn">Save</Button> 
              </Modal.Footer> */}
              </Modal>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default NewDialer;

const styles = {
  dialerRadiosBox: {
    margin: "20px 0",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    backgroundColor: "#f9f9f9",
  },
  cityLabel: {
    fontSize: "15px",
    marginBottom: "5px",
    marginRight: "12px",
  },
  selectBox: {
    width: "400px",
    padding: "5px",
    borderRadius: "3px",
    border: "1px solid #ccc",
  },
};
